import React from 'react';
import { View } from 'react-native';
import { RNCamera } from 'react-native-infy-camera';
import QRCodeScanner from 'react-native-infy-qrcode-scanner';

import { ViewPropTypes } from 'deprecated-react-native-prop-types';
import { PropTypes } from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import FrameworkTestKeys from '../../../FrameworkTestKeys';

import styles from './QRScannerHandler.Styles';

const QRScannerHandler = ({
  theme,
  onQRRead,
  subtitleStyle,
  scannerContainerStyle,
  qrCodeScannerProps,
}) => {
  const renderSubTitle = () => {
    return (
      <VFText
        i18nKey={'voucher_topup_qrscanner_subtitle'}
        style={[styles.subtitle, subtitleStyle]}
        testKey={FrameworkTestKeys.qrScannerSubtitle}
      />
    );
  };
  const renderCameraState = () => (
    <QRCodeScanner
      onRead={e => onQRRead(e.data)}
      topContent={renderSubTitle()}
      topViewStyle={styles.topViewScannerStyle}
      fadeIn={false}
      cameraContainerStyle={[styles.cameraContainerStyle, scannerContainerStyle]}
      flashMode={RNCamera.Constants.FlashMode.auto}
      {...qrCodeScannerProps}
    />
  );

  return (
    <View
      testID={FrameworkTestKeys.qrScannerContainerView}
      style={[styles.containerStyle, scannerContainerStyle]}
    >
      {renderCameraState()}
      <View style={styles.separator(theme)} testID={FrameworkTestKeys.qrScannerSeparator} />
    </View>
  );
};

QRScannerHandler.propTypes = {
  onQRRead: PropTypes.func,
  qrCodeScannerProps: PropTypes.object,
  scannerContainerStyle: ViewPropTypes.style,
  subtitleStyle: PropTypes.object,
  theme: PropTypes.shape({
    colors: PropTypes.object,
    name: PropTypes.string,
  }),
};

export default withTheme(QRScannerHandler);
